/* global Confluence */
export const getLink = function getLink() {
	return Confluence.Link;
};

export default typeof Confluence !== 'undefined' ? Confluence : {};
